import { ChannelManagerMeetingsContextProvider } from "../../ChannelManagerMeetings/Create/Context";
import { ChannelManagerMeetingsBlock } from "./Block";

/**
 * @param {object} params
 * @param {boolean} params.isEditor
 */
export function getChannelManagerMeetingCreateBlock({ isEditor }) {
  return () => (
    <ChannelManagerMeetingsContextProvider isEditor={isEditor}>
      <ChannelManagerMeetingsBlock />
    </ChannelManagerMeetingsContextProvider>
  );
}
